import { NavLink } from 'react-router';
import { BarChart3, FolderKanban, Settings, Timer, Users } from 'lucide-react';
import type { ComponentType } from 'react';
import { cn } from '@/lib/cn';

type Tab = { to: string; label: string; icon: ComponentType<{ size?: number; strokeWidth?: number }>; teamOnly?: boolean };
const TABS: Tab[] = [
  { to: '/timer', label: 'Timer', icon: Timer },
  { to: '/sessions', label: 'Sessions', icon: BarChart3 },
  { to: '/projects', label: 'Projects', icon: FolderKanban },
  { to: '/team', label: 'Team', icon: Users, teamOnly: true },
  { to: '/settings', label: 'Settings', icon: Settings },
];

/** Phone navigation (spec §2): the same items as the desktop top bar, pinned to the bottom edge above the home bar. */
export function BottomNav({ hasTeam }: { hasTeam: boolean }) {
  const tabs = TABS.filter((t) => !t.teamOnly || hasTeam);
  return (
    <nav aria-label="Primary" className="md:hidden fixed inset-x-0 bottom-0 z-30 flex border-t border-header-rule bg-card pb-[env(safe-area-inset-bottom)]">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => cn('flex-1 flex flex-col items-center gap-1 py-2 no-underline', isActive ? 'text-accent' : 'text-ink-2')}>
          {({ isActive }) => (<><t.icon size={20} strokeWidth={isActive ? 2.4 : 2} /><span className="text-[10.5px] font-bold">{t.label}</span></>)}
        </NavLink>
      ))}
    </nav>
  );
}
